module.exports = __webpack_public_path__ + "img/news_title.2218e626.png";